import { gql } from '@apollo/client';

export const MY_COACH_REQUESTS = gql`
  query MyCoachRequests {
    myCoachRequests {
      _id
      coach {
        _id
        firstName
        lastName
        user {
          email
        }
      }
      status
      createdAt
    }
  }
`;